import ReactDOM from 'react-dom';
import { App } from './core/App';
import './styles/commonStyles.css';


ReactDOM.render(
  <App />,
  document.getElementById('root')
)